export const UNITS = {
  KG_TONS_RATIO: 1 / 1000,
}
